<template>
    <div class="max_box">
        <!-- 模型属性 -->
        <!-- 模型属性 -->
        <div class="div_tab" v-show="isQcType"><div class="div_title_span">生效技能组<span style="color: #F56C6C;font-weight: bold;"> * </span></div></div>
        <div class="div_box" v-show="isQcType">
            <el-select
                    v-model="input_data.userList"
                    class="div_input"
                    multiple
                    collapse-tags
                    size="small"
                    clearable
                    :disabled="isEdit() && (!$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430') || !$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101431'))"
                    placeholder="请选择技能组">
                <el-option :label="item.text" :value="item.value" v-for="(item, index) in customerGroup" :key="index"></el-option>
            </el-select>
        </div>
        <div class="div_tab"><div class="div_title_span">模型属性<span style="color: #F56C6C;font-weight: bold;"> * </span></div></div>
        <div class="div_box">
            <el-select class="div_input" v-model="input_data.attrActionId"
                       :disabled="(isEdit() && !$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430'))"
                       placeholder="请选择行为类别" size="small" clearable>
                <!-- el-option label="首次响应不及时" value="1"></el-option>
                <el-option label="静默" value="2"></el-option>
                <el-option label="抢话" value="3"></el-option>
                <el-option label="发送链接" value="4"></el-option>
                <el-option label="发送附件" value="5"></el-option-->
                <el-option :label="item.name" :value="item.code" v-for="(item,index) in behaviorSettingsData" :key="index"></el-option>
            </el-select>
        </div>
        <div class="div_tab"  :disabled="(isEdit() && !$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430'))" v-show="input_data.attrActionId != 'sendAttachment' && input_data.attrActionId != 'sendQrCode' && input_data.attrActionId != ''">
            <div class="div_title_span">模型设置<span style="color: #F56C6C;font-weight: bold;"> * </span>
                <el-popover v-show="input_data.attrActionId == 'sendLink'"
                        placement="right-start"
                        width="150"
                        trigger="hover"
                >
                    <div style="width: auto;">
                        <span style="font-size: 12px;color: #777">坐席向客户发送不合规的链接，记为命中</span>
                    </div>
                    <span style="color: #ee9900;cursor: help;margin-left:5px;" slot="reference"><i class="el-icon-warning-outline"></i></span>
                </el-popover>
            </div>
        </div>
        <!--首次响应不及时-->
        <div class="div_box div_box_font" v-show="input_data.attrActionId == 'firstDelayedResponse'">
            坐席首次响应时间超过
            <el-input-number  :disabled="(isEdit() && !$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430'))"
                              v-model="input_data.attrActionValue"
                              size="mini" class="input_number" controls-position="right" :min="0" :max="9999999"></el-input-number>
            秒，记为命中
        </div>
        <!--抢话-->
        <div class="div_box div_box_font"  v-show="input_data.attrActionId == 'robTalk'" >
            坐席抢话超过
            <el-input-number v-model="input_data.attrActionValue"  :disabled="(isEdit() && !$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430'))" size="mini" class="input_number" controls-position="right" :min="0" :max="9999999"></el-input-number>
            秒，记为命中
        </div>
        <!--  发送附件 -->
        <div class="div_box div_box_font"  v-show="input_data.attrActionId == 'sendAttachment'"></div>
        <!--  发送二维码 -->
        <div class="div_box div_box_font"  v-show="input_data.attrActionId == 'sendQrCode'"></div>
        <!--  静默 -->
        <div class="div_box div_box_font"  v-show="input_data.attrActionId == 'silence'">
            <el-select class="div_input" v-model="input_data.attrRole" value-key="2" placeholder="" size="small" style="width: 150px">
                <el-option label="客户或者坐席" :value="0"></el-option>
                <el-option label="客户" :value="1"></el-option>
                <el-option label="坐席" :value="2"></el-option>
            </el-select>
            说话后超过
            <el-input-number v-model="input_data.attrActionValue"  :disabled="(isEdit() && !$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430'))" size="mini" class="input_number" controls-position="right" :min="0" :max="9999999"></el-input-number>
            秒，对方没有给予回应，记为命中
        </div>
        <!--  发送链接 -->
        <div class="div_box div_box_font"  v-show="input_data.attrActionId == 'sendLink'" style="display: inline-block">
            <div style="width: auto;margin-bottom: 15px;">
                <el-button size="small"  v-show="!(isEdit() && !$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430'))" type="success" @click="addItems" icon="el-icon-plus" style="margin: -10px 10px 0 10px">新增</el-button>
            </div>
            <div class="demo-drawer__content" style="margin-left:10px;width: 100%">
                <el-form :model="formData" style="width: 100%">
                <el-table :data="deadlyItems" align="left" style="width:800px;" max-height="300px" border>
                    <el-table-column label="序号" width="100" type="index" align="center"></el-table-column>
                    <el-table-column label="链接地址"  >
                      <template slot-scope="scope">
                        <el-input  :disabled="(isEdit() && !$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430'))" v-model="scope.row.url" placeholder="请输入链接地址" size="mini"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="类型" width="150px">
                      <template slot-scope="scope">
                      <el-select v-model="scope.row.type" size="mini" style="width: 100%" :disabled="(deadlyItems.length > 1)||(isEdit() && !$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430'))">
                          <el-option
                            v-for="item in linkTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                      </el-select>
                    </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="100px">
                      <template slot-scope="scope">
                          <el-button icon="el-icon-delete"  :disabled="(isEdit() && !$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430'))"
                                  class="table_button" circle size="mini" @click="reomveLink(scope.row.id)" type="danger">
                          </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
              </el-form>
            </div>
        </div>
        <!-- 保存按钮 -->
        <div class="div_box save_box" align="center">
            <el-checkbox v-model="input_data.release"
                         style="margin-right: 30px;"
                         v-if="(!isEdit() && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '101310')) ||  (isEdit() && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '101432'))">发布</el-checkbox>
            <el-button size="small" style="margin-right: 20px;width: 62px" @click="cancel()">取消</el-button>
            <el-button size="small" type="primary" style="margin-right: 5px;width: 62px" @click="save()" v-if="(isEdit() && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430')) || !isEdit()">保存</el-button>
        </div>
    </div>
</template>

<script>
import { behaviorSettingsByStatus, saveBehavioralModel, updateBehavioralModel, getBehavioralModelById } from '@/api/qc/model'

export default {
  name: 'newModel_behaviorModule',
  data() {
    return {
      id: this.$router.currentRoute.query.id,
      input_data: {
        // 模型属性-所属角色
        attrRole: '',
        // 模型属性-行为类别
        attrActionId: '',
        // 模型属性-行为类别值
        attrActionValue: 0,
        // 质检类型
        qcType: '',
        // 模型组别
        groupId: '',
        // 名称
        name: '',
        // 备注
        remark: '',
        // 模型类型
        type: 1,
        // 链接地址
        urlList: [],
        // 选中的技能组
        userList: [],
        id: '',
        // 是否发布
        release: false
      },
      isQcType: false,
      behaviorSettingsData: [],
      deadlyItems: [],
      customerGroup: [],
      linkTypeOptions: [{
        value: 0,
        label: '黑名单'
      }, {
        value: 1,
        label: '白名单'
      }],
      formData: {
        id: ''
      }
    }
  },
  methods: {
    isEdit() {
      if (this.$router.currentRoute.query && this.$router.currentRoute.query.id) {
        return true
      }
      return false
    },
    reomveLink(id) {
      var array = []
      for (var i = 0; i < this.deadlyItems.length; i++) {
        if (this.deadlyItems[i].id !== id) {
          array.push(this.deadlyItems[i])
        }
      }
      this.deadlyItems = array
    },
    addItems() {
      if (this.deadlyItems.length > 0) {
        var itemsData = { id: (new Date()).getTime() + parseInt(Math.random() * (999999 + 1), 10), type: this.deadlyItems[0].type }
        this.deadlyItems.push(itemsData)
      } else {
        var itemsDatas = { id: (new Date()).getTime() + parseInt(Math.random() * (999999 + 1), 10), type: 0 }
        this.deadlyItems.push(itemsDatas)
      }
    },
    cancel() {
      if (window.sessionStorage && window.sessionStorage.getItem('qcModelMgrQueryData')) {
        const json = JSON.parse(window.sessionStorage.getItem('qcModelMgrQueryData'))
        json.isOpen = true
        window.sessionStorage.setItem('qcModelMgrQueryData', JSON.stringify(json))
      }
      if (this.id) {
        this.$router.push('/qc/businessModeling/modelManagement')
      } else {
        this.$router.push('/qc/newModel/newModel_menu')
      }
    },
    save() {
      this.$emit('getFatherData')
      var datas = window.qc_newModel
      // eslint-disable-next-line eqeqeq
      if (datas.group == '') {
        window.qcMessage({ type: 'warning', text: '模型分组不能为空' })
        this.$emit('inputIsNull', 'group')
        // eslint-disable-next-line eqeqeq
      } else if (datas.name == '') {
        window.qcMessage({ type: 'warning', text: '模型名称不能为空' })
        this.$emit('inputIsNull', 'name')
      // eslint-disable-next-line eqeqeq
      } else if (this.isQcType === true && (!this.input_data.userList || this.input_data.userList.length === 0)) {
        window.qcMessage({ type: 'warning', text: '请选择生效技能组' })
        // eslint-disable-next-line eqeqeq
      } else {
        const params = {
          attrRole: this.input_data.attrRole,
          attrActionId: this.input_data.attrActionId,
          attrActionValue: this.input_data.attrActionValue,
          qcType: datas.qcType,
          type: this.input_data.type,
          remark: datas.nemo,
          groupId: datas.group,
          name: datas.name,
          urlList: this.deadlyItems,
          skillGroupId: this.input_data.userList,
          id: this.id,
          flagPublish: this.input_data.release ? 1 : 0
        }
        if (this.id) {
          saveBehavioralModel(params).then(response => {
            // eslint-disable-next-line eqeqeq
            if (response.data.code == 2000) {
              window.qcMessage({ type: 'success', text: '操作成功' })
              this.$router.push('/qc/businessModeling/modelManagement')
            } else {
              window.qcMessage({ type: 'warning', text: response.data.msg })
            }
          }).catch(response => {
            window.qcMessage({ type: 'warning', text: '操作失败' })
          })
        } else {
          updateBehavioralModel(params).then(response => {
            // eslint-disable-next-line eqeqeq
            if (response.data.code == 2000) {
              window.qcMessage({ type: 'success', text: '操作成功' })
              this.$router.push('/qc/businessModeling/modelManagement')
            } else {
              window.qcMessage({ type: 'warning', text: response.data.msg })
            }
          }).catch(response => {
            window.qcMessage({ type: 'warning', text: '操作失败' })
          })
        }
      }
    },
    init() {
      const params = {
        status: '1'
      }
      behaviorSettingsByStatus(params).then(response => {
        this.behaviorSettingsData = response.data.data
      }).catch(response => {
        window.qcMessage({ type: 'warning', text: '操作失败' })
      })
      if (this.$router.currentRoute.query && this.$router.currentRoute.query.id) {
        this.id = this.$router.currentRoute.query.id
        getBehavioralModelById(this.id).then(response => {
          response = response.data.data
          // 提取技能组
          const that = this
          const modelSkillGroups = []
          if (response.modelRelation) {
            this.input_data.userList = []
            response.modelRelation.forEach(function (relationItem, index) {
              modelSkillGroups.push(relationItem.skillGroupId)
            })
          }
          response = response.data
          const json = {
            group: response.groupId,
            name: response.name,
            nemo: response.remark,
            qcType: response.qcType
          }
          this.$emit('setFatherData', json)
          // eslint-disable-next-line eqeqeq
          if (response.qcType == '1') {
            this.isQcType = true
          }
          if (this.isQcType === true) {
            // 取客服组
            this.$qcAuthUtis.qcSkillGroupList('aicc-qc', '101100', function(response) {
              that.customerGroup = []
              response = response.data.data
              for (let i = 0; i < response.length; i++) {
                var json = {
                  text: response[i].name,
                  value: response[i].id
                }
                that.customerGroup.push(json)
                modelSkillGroups.forEach(function (skillItem) {
                  if (json.value === skillItem) {
                    that.input_data.userList.push(skillItem)
                  }
                })
              }
            })
          }
          this.input_data.id = this.id
          this.input_data.attrRole = response.attrRole
          this.input_data.attrActionValue = response.attrActionValue
          this.input_data.attrActionId = response.attrActionId
          this.input_data.release = !!(response.flagPublish === 1)
          this.deadlyItems = []
          for (let i = 0; i < response.urlList.length; i++) {
            const id = response.urlList[i].id
            this.deadlyItems.push({ id: id, url: response.urlList[i].url, type: response.urlList[i].type })
          }
        }).catch(response => {
        })
      } else {
        // 验证是否为实时质检
        this.$emit('getFatherData')
        // eslint-disable-next-line eqeqeq
        if (window.qc_newModel.qcType == '1') {
          this.isQcType = true
        }
        // eslint-disable-next-line eqeqeq
        if (this.isQcType == true) {
          // 取客服组
          const that = this
          this.$qcAuthUtis.qcSkillGroupList('aicc-qc', '101100', function(response) {
            that.customerGroup = []
            response = response.data.data
            for (var i = 0; i < response.length; i++) {
              var json = {
                text: response[i].name,
                value: response[i].id
              }
              that.customerGroup.push(json)
            }
          })
        }
      }
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>
    .max_box{
        width: 100%;
        display: inline-block;
        padding: 10px 0 0 0;
    }
    .div_title_span {
        border-left: #357cfd solid 3px;
        line-height: 6px;
        height: 12px;
        padding-left: 10px;
        line-height: 10px;
        font-size: 15px;
        color: #666;
    }
    .div_tab{
        width: 100%;
        color: #333333;
        margin-top: 20px;
        border-bottom: #e1e3e6 solid 1px;
        padding-bottom: 10px;
    }
    .div_box{
        width: 100%;
        padding: 15px 0 25px 0;
        display: inline-block;
        margin-top: 10px;
    }
    .div_input{
        width: 200px;
    }
    .div_span{
        margin-right:10px;
        font-size: 14px;
        color: #333;
    }
    .div_box_font{
        font-size: 14px;
        color: #666;
    }
    .save_box{
        margin-top: 20px;
        margin-bottom: 20px;
        padding-top: 0px!important;
    }
    .input_number{
        width:80px;
        margin: 0 5px;
    }
    .input_number.el-input-number.is-controls-right>>>.el-input>input{
        padding-left: 3px !important;
        padding-right: 30px !important;
    }
</style>
